var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodexIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1208 1208",
    width: 1208,
    height: 1208,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon (1)-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #f9c041 } \n\t\t.shp1 { fill: #3fc2a0 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "shp0",
    d: "M805.81 237.75C730.71 237.75 660.91 260.44 602.86 299.3C702.72 364.51 768.76 477.18 768.76 605.34C768.76 732.01 704.28 843.59 606.37 909.13L606.37 909.13C663.73 946.58 732.2 968.43 805.81 968.43C1007.58 968.43 1171.15 804.86 1171.15 603.09C1171.15 401.32 1007.58 237.75 805.81 237.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "shp1",
    d: "M440.47 603.09C440.47 476.43 504.95 364.84 602.86 299.3L602.86 299.3C545.51 261.85 477.03 240 403.42 240C201.65 240 38.08 403.57 38.08 605.34C38.08 807.11 201.65 970.68 403.42 970.68C478.53 970.68 548.32 947.99 606.37 909.13C506.52 843.92 440.47 731.25 440.47 603.09Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodexIcon);
export default __webpack_public_path__ + "static/media/codex-icon.281a680180af2a25548925a678945f1d.svg";
export { ForwardRef as ReactComponent };